@if (!preview) {
    <div
        class="space-y-4 px-10 py-4 border-2 border-gray-900/10 rounded-md"
        [ngClass]="error ? 'border-red-500' : 'border-gray-900/10'"
    >
        <div class="mb-6">
            <div class="text-lg font-semibold my-1">Ime i prezime</div>
            <div class="w-1/3">
                <input
                    class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                    [(ngModel)]="fullName"
                    (input)="onFullNameChange()"
                    type="text"
                />
            </div>
        </div>

        <valben-file-input
            title="Prenesi potvrdu o porezu na dohodak"
            key="taxIncomeDocument"
            [itemObservable]="taxDocumentItemObservable"
            [update]="onTaxDocumentChange"
            fileType="application/pdf"
            [isKng]="true"
            [optional]="false"
        ></valben-file-input>

        <valben-file-input
            title="Prenesi dokument o vlasništvu nekretnine"
            key="ownsPropertyDocument"
            [itemObservable]="ownsPropertyDocumentItemObservable"
            [update]="onOwnsPropertyDocumentChange"
            fileType="application/pdf"
            [isKng]="true"
            [optional]="false"
        ></valben-file-input>

        @if (showMonthlyIncome) {
            <div>
                <div class="text-lg font-semibold my-1">Mjesečni prihod</div>
                <div class="w-1/5">
                    <input
                        class="w-full h-10 border focus:outline-none rounded-md text-md p-2"
                        [(ngModel)]="monthlyIncomeValue"
                        (input)="onMonthlyIncomeChange()"
                        type="text"
                    />
                </div>
            </div>
        }
    </div>
}

@if (preview) {
    <div class="space-y-4 px-10 py-4 border-2 border-gray-900/10 rounded-md">
        <div class="flex items-center gap-2 mb-6">
            <span class="text-lg font-semibold">Ime i prezime</span>
            <span class="text-md">{{ fullName && fullName.trim() !== '' ? fullName : '-' }}</span>
        </div>

        <valben-file-input
            title="Potvrda o porezu na dohodak"
            key="taxIncomeDocument"
            [itemObservable]="taxDocumentItemObservable"
            [update]="onTaxDocumentChange"
            fileType="application/pdf"
            [isKng]="true"
            [preview]="true"
        ></valben-file-input>

        <valben-file-input
            title="Dokument o vlasništvu nekretnine"
            key="ownsPropertyDocument"
            [itemObservable]="ownsPropertyDocumentItemObservable"
            [update]="onOwnsPropertyDocumentChange"
            fileType="application/pdf"
            [isKng]="true"
            [preview]="true"
        ></valben-file-input>

        @if (showMonthlyIncome) {
            <div class="flex items-center gap-2">
                <span class="text-lg font-semibold">Mjesečni prihod</span>
                <span class="text-md">{{ monthlyIncomeValue || '-' }}</span>
            </div>
        }
    </div>
}
